<script setup>
  import { inject, computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  const tournament = inject('tournament')
  const editMode = inject('editMode')

  const { t } = useI18n()

  const menuItems = computed(() => {
    const items = []
    if (editMode && editMode.value) {
      items.push({ title: t('label.manage'), type: 'subheader' })
      items.push({
        title: t('label.manage_entries'),
        icon: 'mdi-account-group-outline',
        route: { name: 'tournament-entries' }
      })
      if (tournament.value.settings?.useTeams) {
        items.push({
          title: t('label.manage_teams'),
          icon: 'mdi-shield-star-outline',
          route: { name: 'tournament-teams' }
        })
      }
      items.push({
        title: t('navigation.settings'),
        icon: 'mdi-cog-outline',
        route: { name: 'tournament-settings' }
      })
      items.push({
        title: t('label.format'),
        icon: 'mdi-tournament',
        route: { name: 'tournament-format' }
      })
      items.push({
        title: t('navigation.actions'),
        icon: 'mdi-flash-outline',
        route: { name: 'tournament-actions' }
      })

      items.push('divider')
    }

    // items.push({
    //   title: t('label.fixtures'),
    //   icon: 'mdi-calendar-outline',
    //   toSection: '#fixtures'
    // })

  items.push({ title: t('label.competition'), type: 'subheader' })
  items.push({ title: t('label.standings'), icon: 'mdi-podium', route: { name: 'tournament-show' } })
  items.push({ title: 'HOF', icon: 'mdi-star-outline', route: { name: 'tournament-hof' } })
  items.push({ title: t('label.tournament_info'), icon: 'mdi-information-outline', route: { name: 'tournament-info' } })

    return items
  })
</script>

<template>
  <v-menu>
    <template v-slot:activator="{ props }">
      <v-btn
        icon="mdi-dots-vertical"
        variant="text"
        v-bind="props"
      ></v-btn>
    </template>
    
    <v-list>
      <template v-for="(item, index) in menuItems" :key="index">
        <v-divider v-if="item.type === 'divider'"></v-divider>

        <v-list-subheader v-else-if="item.type == 'subheader'"
          class="justify-center text-uppercase"
        >
          {{ item.title }}
        </v-list-subheader>

        <v-list-item v-else
          :value="'mobile-' + index"
          :prepend-icon="item.icon"
          :to="item.route ?? null"
          :href="item.toSection ?? null"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        
      </template>
    </v-list>
  </v-menu>
</template>